import { FormLayout } from './FormLayout';

export const createPreviewUrl = (layout: FormLayout, key: string, version: number) => {
  return layout === 'document'
    ? `/ClinicianPreview/${key}/${version}/edit`
    : `/SinglePassDemo/${key}/${version}`;
};
